import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import FiltersBar from './components/FiltersBar';
import { getWarehouseData } from '../../redux/operational-dashboard-warehouse';
import { getDistributionData } from '../../redux/operational-dashboard-distribution';
import { getVehiclesData } from '../../redux/operational-dashboard-vehicles';

import './styles.css';

class OperationalDashboard extends React.Component {
  _onFilterWarehouseData = async (type, searchParams) => {
    const dashboardData = {
      deposito: async () => {
        await this.props.getWarehouseData(searchParams);
      },
      distribuicao: async () => {
        await this.props.getDistributionData(searchParams);
      },
      veiculos: async () => {
        await this.props.getVehiclesData(searchParams);
      },
    };

    // await this.props.getWarehouseData(searchParams);
    await dashboardData[type]();
  };

  render() {
    const { children } = this.props;
    return (
      <div className="root-operational-dashboard">
        <div className="OperationalDashboard_FilterContainer">
          <FiltersBar onFilter={this._onFilterWarehouseData} />
        </div>
        {children}
      </div>
    );
  }
}

const mapActionsToProps = {
  getWarehouseData,
  getDistributionData,
  getVehiclesData,
};

const mapStateToProps = state => ({
  isFetching:
    state.operationalDashboardDistribution.isFetching ||
    state.operationalDashboardWarehouse.isFetching ||
    state.operationalDashboardVehicles.isFetching,
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(withRouter(OperationalDashboard));
